// src/pages/BlogDetails.jsx
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import blogData from '../data/blogData';
import '../styles/BlogDetails.css';

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogData.find((item) => item.id === parseInt(id, 10));

  if (!blog) {
    return (
      <div className="blog-details">
        <h2>Blog Not Found</h2>
        <Link to="/blog">← Back to Blog</Link>
      </div>
    );
  }

  return (
    <div className="blog-details">
      {/* <h1>{blog.title}</h1> */}
      {/* <p className="blog-content">{blog.content}</p> */}
      <div
        className="prose prose-lg"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
      <Link className="back-link" to="/blog">← Back to Blog</Link>
    </div>
  );
};

export default BlogDetails;
